import React from 'react';
import { Plus, Search, Check, Clock, Pill, MoreVertical, Bell, Calendar } from 'lucide-react';
export function Medications() {
  return <div className="p-8 max-w-7xl mx-auto space-y-8" data-id="element-243">
      {/* Header */}
      <div className="flex justify-between items-end" data-id="element-244">
        <div data-id="element-245">
          <h1 className="text-3xl font-bold text-slate-900" data-id="element-246">Medications</h1>
          <p className="text-slate-500 mt-1" data-id="element-247">Manage your prescriptions</p>
        </div>
        <button className="flex items-center gap-2 bg-slate-800 hover:bg-slate-900 text-white px-4 py-2 rounded-lg text-sm font-medium transition-colors" data-id="element-248">
          <Plus className="w-4 h-4" data-id="element-249" /> Add
        </button>
      </div>

      {/* Today's Reminders */}
      <div className="bg-slate-800 rounded-2xl p-6 text-white shadow-lg relative overflow-hidden" data-id="element-250">
        <div className="flex items-center gap-2 mb-6" data-id="element-251">
          <Bell className="w-5 h-5 text-emerald-400" data-id="element-252" />
          <h3 className="font-semibold text-lg" data-id="element-253">Today's Reminders</h3>
        </div>

        <div className="space-y-3" data-id="element-254">
          {/* Active Reminder */}
          <div className="bg-white/10 rounded-xl p-4 backdrop-blur-sm border border-white/10" data-id="element-255">
            <div className="flex justify-between items-start mb-4" data-id="element-256">
              <div className="flex items-center gap-3" data-id="element-257">
                <div className="w-10 h-10 bg-white/20 rounded-lg flex items-center justify-center" data-id="element-258">
                  <Pill className="w-5 h-5 text-white" data-id="element-259" />
                </div>
                <div data-id="element-260">
                  <p className="font-bold" data-id="element-261">Metformin</p>
                  <p className="text-sm text-slate-300" data-id="element-262">500mg</p>
                </div>
              </div>
              <div className="text-right" data-id="element-263">
                <p className="font-bold text-xl" data-id="element-264">20:00</p>
                <p className="text-xs text-slate-300" data-id="element-265">Next</p>
              </div>
            </div>
            <button className="w-full bg-white text-slate-900 py-2.5 rounded-lg font-medium text-sm hover:bg-slate-100 transition-colors flex items-center justify-center gap-2" data-id="element-266">
              <Check className="w-4 h-4" data-id="element-267" /> Take Now
            </button>
          </div>

          {/* Upcoming/Past List */}
          <div className="space-y-1 mt-4" data-id="element-268">
            <div className="flex items-center justify-between p-3 rounded-lg hover:bg-white/5 transition-colors opacity-50" data-id="element-269">
              <div className="flex items-center gap-3" data-id="element-270">
                <Check className="w-4 h-4 text-emerald-400" data-id="element-271" />
                <span className="line-through text-slate-300" data-id="element-272">Metformin</span>
              </div>
              <span className="text-sm text-slate-400" data-id="element-273">08:00</span>
            </div>
            <div className="flex items-center justify-between p-3 rounded-lg hover:bg-white/5 transition-colors opacity-50" data-id="element-274">
              <div className="flex items-center gap-3" data-id="element-275">
                <Check className="w-4 h-4 text-emerald-400" data-id="element-276" />
                <span className="line-through text-slate-300" data-id="element-277">Vitamin D3</span>
              </div>
              <span className="text-sm text-slate-400" data-id="element-278">09:00</span>
            </div>
            <div className="flex items-center justify-between p-3 rounded-lg hover:bg-white/5 transition-colors" data-id="element-279">
              <div className="flex items-center gap-3" data-id="element-280">
                <Clock className="w-4 h-4 text-slate-300" data-id="element-281" />
                <span data-id="element-282">Metformin</span>
              </div>
              <span className="text-sm text-slate-300" data-id="element-283">20:00</span>
            </div>
          </div>
        </div>
      </div>

      {/* Search & Tabs */}
      <div className="space-y-6" data-id="element-284">
        <div className="relative" data-id="element-285">
          <Search className="absolute left-4 top-1/2 transform -translate-y-1/2 text-slate-400 w-5 h-5" data-id="element-286" />
          <input type="text" placeholder="Search medications..." className="w-full pl-12 pr-4 py-3 bg-white border border-slate-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent" data-id="element-287" />
        </div>

        <div className="flex justify-between items-center border-b border-slate-200 pb-1" data-id="element-288">
          <div className="flex gap-8" data-id="element-289">
            <button className="pb-3 border-b-2 border-slate-900 font-medium text-slate-900 flex items-center gap-2" data-id="element-290">
              Active{' '}
              <span className="bg-slate-900 text-white text-xs py-0.5 px-2 rounded-full" data-id="element-291">
                2
              </span>
            </button>
            <button className="pb-3 border-b-2 border-transparent text-slate-500 hover:text-slate-700 font-medium flex items-center gap-2" data-id="element-292">
              Completed{' '}
              <span className="bg-slate-100 text-slate-500 text-xs py-0.5 px-2 rounded-full" data-id="element-293">
                0
              </span>
            </button>
            <button className="pb-3 border-b-2 border-transparent text-slate-500 hover:text-slate-700 font-medium flex items-center gap-2" data-id="element-294">
              All{' '}
              <span className="bg-slate-100 text-slate-500 text-xs py-0.5 px-2 rounded-full" data-id="element-295">
                3
              </span>
            </button>
          </div>
        </div>
      </div>

      {/* Medication Cards */}
      <div className="space-y-4" data-id="element-296">
        {/* Card 1 */}
        <div className="bg-white rounded-2xl p-6 border border-slate-100 shadow-sm" data-id="element-297">
          <div className="flex justify-between items-start mb-6" data-id="element-298">
            <div className="flex items-start gap-4" data-id="element-299">
              <div className="w-12 h-12 bg-slate-800 rounded-xl flex items-center justify-center" data-id="element-300">
                <Pill className="w-6 h-6 text-white" data-id="element-301" />
              </div>
              <div data-id="element-302">
                <h3 className="font-bold text-lg text-slate-900" data-id="element-303">Metformin</h3>
                <p className="text-slate-500" data-id="element-304">500mg</p>
                <div className="flex items-center gap-3 mt-2" data-id="element-305">
                  <span className="flex items-center gap-1 text-xs font-medium text-slate-600 bg-slate-100 px-2 py-1 rounded-md" data-id="element-306">
                    <Clock className="w-3 h-3" data-id="element-307" /> Twice daily
                  </span>
                  <span className="text-xs text-slate-400 bg-slate-50 px-2 py-1 rounded-md" data-id="element-308">
                    08:00
                  </span>
                  <span className="text-xs text-slate-400 bg-slate-50 px-2 py-1 rounded-md" data-id="element-309">
                    20:00
                  </span>
                </div>
                <p className="text-xs text-slate-400 mt-2 flex items-center gap-1" data-id="element-310">
                  <span className="w-1 h-1 bg-slate-400 rounded-full" data-id="element-311"></span>{' '}
                  Take with meals
                </p>
              </div>
            </div>
            <div className="flex items-center gap-2" data-id="element-312">
              <span className="text-xs font-medium text-emerald-600 bg-emerald-50 px-2 py-1 rounded-full" data-id="element-313">
                active
              </span>
              <button className="text-slate-400 hover:text-slate-600" data-id="element-314">
                <MoreVertical className="w-5 h-5" data-id="element-315" />
              </button>
            </div>
          </div>

          <div className="pt-4 border-t border-slate-50 flex items-center justify-between" data-id="element-316">
            <p className="text-xs text-slate-400 flex items-center gap-1" data-id="element-317">
              <Calendar className="w-3 h-3" data-id="element-318" /> Started Jan 1, 2026
            </p>
            <button className="w-full max-w-xs bg-slate-100 hover:bg-slate-200 text-slate-700 py-2 rounded-lg text-sm font-medium transition-colors flex items-center justify-center gap-2" data-id="element-319">
              <Check className="w-4 h-4" data-id="element-320" /> Log as Taken
            </button>
          </div>
        </div>

        {/* Card 2 */}
        <div className="bg-white rounded-2xl p-6 border border-slate-100 shadow-sm" data-id="element-321">
          <div className="flex justify-between items-start mb-6" data-id="element-322">
            <div className="flex items-start gap-4" data-id="element-323">
              <div className="w-12 h-12 bg-slate-800 rounded-xl flex items-center justify-center" data-id="element-324">
                <Pill className="w-6 h-6 text-white" data-id="element-325" />
              </div>
              <div data-id="element-326">
                <h3 className="font-bold text-lg text-slate-900" data-id="element-327">Vitamin D3</h3>
                <p className="text-slate-500" data-id="element-328">2000 IU</p>
                <div className="flex items-center gap-3 mt-2" data-id="element-329">
                  <span className="flex items-center gap-1 text-xs font-medium text-slate-600 bg-slate-100 px-2 py-1 rounded-md" data-id="element-330">
                    <Clock className="w-3 h-3" data-id="element-331" /> Once daily
                  </span>
                  <span className="text-xs text-slate-400 bg-slate-50 px-2 py-1 rounded-md" data-id="element-332">
                    09:00
                  </span>
                </div>
                <p className="text-xs text-slate-400 mt-2 flex items-center gap-1" data-id="element-333">
                  <span className="w-1 h-1 bg-slate-400 rounded-full" data-id="element-334"></span>{' '}
                  Take after breakfast
                </p>
              </div>
            </div>
            <div className="flex items-center gap-2" data-id="element-335">
              <span className="text-xs font-medium text-emerald-600 bg-emerald-50 px-2 py-1 rounded-full" data-id="element-336">
                active
              </span>
              <button className="text-slate-400 hover:text-slate-600" data-id="element-337">
                <MoreVertical className="w-5 h-5" data-id="element-338" />
              </button>
            </div>
          </div>

          <div className="pt-4 border-t border-slate-50 flex items-center justify-between" data-id="element-339">
            <p className="text-xs text-slate-400 flex items-center gap-1" data-id="element-340">
              <Calendar className="w-3 h-3" data-id="element-341" /> Started Jan 15, 2026
            </p>
            <button className="w-full max-w-xs bg-emerald-50 text-emerald-600 py-2 rounded-lg text-sm font-medium flex items-center justify-center gap-2 cursor-default" data-id="element-342">
              <Check className="w-4 h-4" data-id="element-343" /> Taken at 09:05
            </button>
          </div>
        </div>
      </div>
    </div>;
}